import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const secureFiltersDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'filters-directory-secure-redirect',
	path: '/secure/ManageFilters.jspa',
};
